import { Pipe, PipeTransform, inject } from '@angular/core';

import { AccountTypeMapper } from '../../services/account-type-mapper/account-type.mapper';
import { LoggerService } from '../../services/logger/logger.service';

@Pipe({
    name: 'mapAccType',
})
export class MapAccountTypePipe implements PipeTransform {
    private logger = inject(LoggerService);
    private readonly accountTypeMapper = inject(AccountTypeMapper);


    transform(code: string) {
        const userFriendlyValue = this.accountTypeMapper.mapCodeToAccountType(code);
        if (!userFriendlyValue) {
            this.logger.warn(
                `Mapping warn - Account Type | Unable to map ${code} to its user friendly value`,
            );
        }
        return userFriendlyValue;
    }
}
